import axios from 'axios'

// initial state
const state = () => ({
  result: [],
  count: -1
})

// getters
const getters = {}

// actions
const actions = {
  Query ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Orders/Query', value)
        .then(response => {
          commit('Query', response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  },
  Clear ({ commit }, value) {
    commit('Clear', [])
  },
  // 單筆查詢
  Detail ({ commit }, value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/Orders/Detail', value)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error.message)
          reject(error)
        })
    })
  }
}

// mutations
const mutations = {
  Query (state, value) {
    state.result = value.Data
    state.count = value.PageCount
  },
  Clear (state) {
    state.result = []
    state.count = -1
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
